<template>
  <div class="txn-page">
    <div class="txn-inner">
      <section class="txn-card" aria-label="Withdraw">
        <h1 class="txn-title">
          {{
            $store.state.language === 'en'
              ? 'Withdraw'
              : 'ငွေထုတ်'
          }}
        </h1>
        <div class="txn-body">
          <form @submit.prevent>
            <div class="txn-field">
              <label class="txn-label" for="withdraw-method">{{
                $store.state.language === 'en'
                  ? 'Choose withdrawal method'
                  : 'ငွေထုတ်ယူမူပုံစံ ရွေးချယ်ပါ'
              }}</label>
              <AccountSelect
                :data="selected_account"
                field="account_id"
                :accounts="accounts"
                variant="withdraw"
              />
              <p v-if="errors.account" class="txn-field-error">{{ errors.account }}</p>
            </div>

            <div class="txn-field">
              <label class="txn-label" for="withdraw-number">{{
                $store.state.language === 'en'
                  ? 'Account number'
                  : 'ငွေလက်ခံမည့် အကောင့် နံပါတ်'
              }}</label>
              <input
                id="withdraw-number"
                type="number"
                class="txn-input"
                :placeholder="$store.state.language === 'en' ? 'Account number' : 'အကောင့် နံပါတ်'"
                v-model="withdrawData.account_number"
              >
              <p v-if="errors.number" class="txn-field-error">{{ errors.number }}</p>
            </div>

            <div class="txn-field">
              <label class="txn-label" for="withdraw-name">{{
                $store.state.language === 'en'
                  ? 'Account name'
                  : 'ငွေလက်ခံမည့် အကောင့်နာမည်'
              }}</label>
              <input
                id="withdraw-name"
                type="text"
                class="txn-input"
                :placeholder="$store.state.language === 'en' ? 'Account holder name' : 'အကောင့် အမည်'"
                v-model="withdrawData.account_name"
              >
              <p v-if="errors.name" class="txn-field-error">{{ errors.name }}</p>
            </div>

            <div class="txn-field">
              <label class="txn-label" for="withdraw-amount">{{
                $store.state.language === 'en'
                  ? 'Amount'
                  : 'ငွေပမာဏ'
              }}</label>
              <span class="txn-hint">{{
                $store.state.language === 'en'
                  ? `Minimum ${minWithdrawAmount.toLocaleString()} MMK`
                  : `အနည်းဆုံး ${minWithdrawAmount.toLocaleString()} ကျပ်`
              }}</span>
              <span v-if="paymentMode === 'auto'" class="txn-hint txn-hint--auto">{{
                $store.state.language === 'en'
                  ? 'Auto withdraw — processed by payment gateway'
                  : 'Auto ငွေထုတ် — payment gateway မှ အလိုအလျောက် လုပ်ဆောင်ပါမည်'
              }}</span>
              <input
                id="withdraw-amount"
                type="number"
                class="txn-input"
                :placeholder="$store.state.language === 'en' ? 'Amount' : 'ငွေပမာဏ'"
                v-model="withdrawData.amount"
              >
              <p v-if="errors.amount" class="txn-field-error">{{ errors.amount }}</p>
            </div>

            <div class="txn-field">
              <label class="txn-label" for="withdraw-remark">{{
                $store.state.language === 'en'
                  ? 'Remark (optional)'
                  : 'မှတ်ချက်'
              }}</label>
              <textarea
                id="withdraw-remark"
                rows="3"
                class="txn-input txn-textarea"
                :placeholder="$store.state.language === 'en' ? 'Notes' : 'မှတ်ချက်'"
                v-model="withdrawData.remark"
              />
            </div>

            <button
              type="button"
              class="txn-submit"
              :disabled="isConfirm"
              @click="sendWithdrawData"
            >
              <Loading
                v-if="isConfirm"
                color="#ffffff"
                size="24"
                class="txn-submit__loading"
              />
              <span v-else>{{
                $store.state.language === 'en'
                  ? 'Confirm'
                  : 'အတည်ပြုမည်'
              }}</span>
            </button>
          </form>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      accounts: [
        {
          name: 'KBZ pay',
          id: 'KBZ pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
        },
        {
          name: 'Wave pay',
          id: 'Wave pay',
          link: 'https://cdn.gold549.com/build/assets/img/payments/wavepay.png',
        },
      ],
      account: [],
      withdrawData: {},
      paymentMode: 'manual',
      errors: {},
      isConfirm: false,
    };
  },
  computed: {
    minWithdrawAmount() {
      return this.paymentMode === 'auto' ? 2000 : 5000;
    },
    currentTime() {
      return moment(this.createDateWithTimeZone()).format('lll');
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    resolvePaymentMode() {
      this.paymentMode = this.$store.state.disableJson?.payments?.withdraw_mode || 'manual';
    },
    async sendWithdrawData() {
      try {
        const authUser = await this.fetchUser();
        this.errors = {};
        if (!this.selected_account.account_id) {
          this.errors.account = this.$store.state.language === 'en'
            ? 'Please pick account type'
            : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
          return false;
        }
        if (!this.withdrawData.account_number) {
          this.errors.number = this.$store.state.language === 'en'
            ? 'Please enter account number'
            : 'ငွေလက်ခံမည့် အကောင့်နံပါတ် ထည့်သွင်းပေးပါ။';
          return false;
        }
        if (!this.withdrawData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
          return false;
        }
        if (this.withdrawData.amount < this.minWithdrawAmount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? `Please enter at least ${this.minWithdrawAmount} MMK`
            : `ငွေပမာဏအနည်းဆုံး ${this.minWithdrawAmount} ထည့်ပေးပါ။`;
          return false;
        }
        if (!this.withdrawData.account_name) {
          this.errors.name = this.$store.state.language === 'en'
            ? 'Please enter payment account name'
            : 'ငွေလက်ခံမည့် အကောင့်နာမည် ထည့်သွင်းပေးပါ။';
          return false;
        }
        if (this.withdrawData.amount > parseInt(authUser.amount, 10)) {
          const balanceError = this.$store.state.language === 'en'
            ? "You don't have sufficient balance"
            : 'အကောင့်ထဲတွင် ပိုက်ဆံအလုံအလောက် မရှိပါ။';
          Dialog.alert({
            message: balanceError,
            confirmButtonText:
              this.$store.state.language === 'en'
                ? 'Go Back'
                : 'နောက်သို့ပြန်သွားမည်။',
          });
          return false;
        }
        if (this.isConfirm) {
          return false;
        }
        this.isConfirm = true;
        this.withdrawData.type = this.selected_account.account_id;
        this.withdrawData.date = this.currentTime;
        const res = await axios.post('/withdraws', this.withdrawData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        if (res.data.payment_mode) {
          this.paymentMode = res.data.payment_mode;
        }
        this.withdrawData = {};
        this.selected_account.account_id = null;
        Toast.success(
          this.$store.state.language === 'en'
            ? (this.paymentMode === 'auto' ? 'Submitted — processing via gateway' : 'Success')
            : (this.paymentMode === 'auto' ? 'တင်ပြီး — gateway မှ လုပ်ဆောင်နေပါသည်' : 'အောင်မြင်သည်။'),
        );
        this.isConfirm = false;
        await this.fetchUser();
      } catch (error) {
        this.isConfirm = false;
        let errorMessage = 'ငွေထုတ်၍ မရသေးပါ။ Customer service သို့ဆက်သွယ်ပေးပါ။';
        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
          errorMessage = error.response.data.error;
        }
        Dialog.alert({
          message: errorMessage,
          confirmButtonText:
            this.$store.state.language === 'en'
              ? 'Go Back'
              : 'နောက်သို့ပြန်သွားမည်။',
        });
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();
      return new Date(year, month, day, hour, minute, second, millisecond);
    },
  },
  async mounted() {
    this.resolvePaymentMode();
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
  },
};
</script>
<style scoped>
.txn-page {
  min-height: 100vh;
  padding: 1rem 0.75rem 1.25rem;
  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom, 0px));
  background-color: #0d0e12;
  background-image: linear-gradient(180deg, rgba(13, 14, 18, 0.92) 0%, rgba(13, 14, 18, 0.88) 100%),
    url('https://storage.googleapis.com/spacetech2/mdl/bg.png');
  background-size: cover;
  background-position: center top;
  background-attachment: scroll;
  -webkit-overflow-scrolling: touch;
}

.txn-inner {
  margin: 0 auto;
  max-width: 32rem;
}

.txn-card {
  background: #1d1f26;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  margin-bottom: 1rem;
  overflow: hidden;
}

.txn-title {
  color: #e8eaef;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 0;
  padding: 0.85rem 1rem 0.35rem;
  text-transform: uppercase;
}

.txn-body {
  padding: 0.5rem 1.125rem 1.35rem;
}

.txn-field {
  margin-bottom: 1.35rem;
}

.txn-label {
  color: #8b95a8;
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.txn-hint {
  color: #5c6478;
  display: block;
  font-size: 0.8rem;
  margin: -0.1rem 0 0.5rem;
}

.txn-hint--auto {
  color: #8ab4ff;
  margin-top: 0.35rem;
}

.txn-input {
  background: #252830 !important;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  color: #f0f2f5 !important;
  font-size: 1rem !important;
  line-height: 1.4 !important;
  min-height: 3.35rem;
  padding: 0.9rem 1rem !important;
  width: 100%;
}

.txn-textarea {
  line-height: 1.45 !important;
  min-height: 6.5rem !important;
  padding-top: 0.95rem !important;
  padding-bottom: 0.95rem !important;
  resize: vertical;
}

.txn-input:focus {
  box-shadow: 0 0 0 2px rgba(92, 152, 255, 0.45) !important;
  outline: none !important;
}

.txn-input::placeholder {
  color: #5c6478;
}

.txn-field-error {
  color: #ff6b7a;
  font-size: 0.8125rem;
  margin: 0.45rem 0 0;
}

.txn-submit {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: linear-gradient(180deg, #6a9fff 0%, #5c98ff 100%);
  border: none;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  font-weight: 600;
  justify-content: center;
  min-height: 3.35rem;
  padding: 0.8rem 1rem;
  transition: filter 0.15s ease;
  width: 100%;
}

.txn-submit:disabled {
  cursor: wait;
  opacity: 0.85;
}

.txn-submit:not(:disabled):active {
  filter: brightness(1.05);
}

.txn-submit__loading {
  padding: 0 !important;
}
</style>
